import React, { useEffect } from 'react'
import { Redirect } from "react-router-dom";
import { useStoreActions, useStoreState } from "easy-peasy";
import Flinks from './flinks/flink';
import Plaid from './plaid/plaid';
import Features from "../../../services/features";

function LinkBankAccount() {

    const mainPath = useStoreState((state) => state.siteSettingsModel.MainPath);
    const setApplicationResult = useStoreActions((actions) => actions.applicationResultModel.setApplicationResult);
    const features = new Features();

    const plaidEnabled = features.isFeatureEnabled('PlaidActive');
    //Flinks has been temporarily removed
    //const flinksEnabled = features.isFeatureEnabled('FlinksActive');
    const flinksEnabled = false;

    useEffect(() => {
        if (!plaidEnabled && !flinksEnabled) {
            setApplicationResult({ result: "SYS_ERROR" });
        }
    }, [plaidEnabled, flinksEnabled, setApplicationResult]);

    if (plaidEnabled) {
        return <Plaid />;
    }

    if (flinksEnabled) {
        return <Flinks />;
    }
    
    return <Redirect to={mainPath + "decision" + window.location.search} />;

}

export default LinkBankAccount